import {Component, OnInit} from '@angular/core';
@Component({
    selector: 'acabim-admin-cap-config',
    templateUrl: './cap-config.component.html'
})

export class ACAAdminCapConfigComponent implements OnInit {
    constructor() { }

    ngOnInit(): void {
    }
}
